import { gql } from "@apollo/client";

export const CORE_LICENCE_FIELDS = gql`
  fragment CoreLicenceFields on Licence {
    id
    productName
    type
    startDate
    endDate
    numberOfUsers
    isArchived
    status
    isActive
    isAutoRenewalCancelled
    organization {
      id
      name
    }
  }
`;
